import { render } from "./HeroBanners.vue?vue&type=template&id=45db169f"
import script from "./HeroBanners.vue?vue&type=script&lang=js"
export * from "./HeroBanners.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__